<script setup>
import {Carousel, Navigation, Slide} from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import {useRoute} from "vue-router";
import {GET_NEWS, GET_NEWS_BY_SLUG} from "@/graphql/operations/news.ts";
import {useQuery} from "@vue/apollo-composable";
import {ref, watch} from "vue";

const route = useRoute();
const url = process.env.VUE_APP_SERVER_URL; // đổi từ process.env sang import.meta.env
const params = route.params.title;

const detail = ref([]);
const data = ref([]);
const title = ref("");

const {result: news, refetch: refetchNews} = useQuery(GET_NEWS_BY_SLUG, () => ({
  slug: params[1],
}));

const {result: newsList, refetch: refetchNewsList} = useQuery(GET_NEWS, () => ({
  slug: params[1],
}));

watch(newsList, () => {
  data.value = newsList.value?.news;
}, {deep: true});

watch(news, () => {
  detail.value = news.value?.news[0]?.data;
  title.value = news.value?.news[0]?.data?.title;
}, {deep: true});

watch(() => route.params.title, (dataParam) => {
  refetchNews({slug: dataParam[1]});
  refetchNewsList({slug: dataParam[1]});
});

const settings = {
  itemsToShow: 1,
  snapAlign: "center",
};

const breakpoints = {
  575: {
    itemsToShow: 1,
    snapAlign: "center",
  },
  767: {
    itemsToShow: 1,
    snapAlign: "center",
  },
  991: {
    itemsToShow: 2,
    snapAlign: "start",
  },
  1024: {
    itemsToShow: 3,
    snapAlign: "start",
  },
};

function toggleSelected(item) {
  item.isSelected = !item.isSelected;
}
</script>

<template>
  <div class="main-wrapper blog">
    <layouts-header v-if="!authStore.user"></layouts-header>
    <user-header v-if="authStore.user"></user-header>
    <breadcrumb :text="text" :text1="text1" :title="title"/>
    <div class="content blog-details">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-md-10 col-lg-8 mx-auto">
            <!-- Blog -->
            <strong v-if="detail.short_description" >{{ detail.short_description }}
              <hr/>
            </strong>
            <div v-if="detail" v-html="detail?.description"></div>
          </div>
        </div>
      </div>
      <section class="section dull-bg similar-list">
        <div class="container">
          <h2 class="text-center mb-40">Tin tức liên quan</h2>
          <div class="row">
            <div class="featured-slider-group">
              <div class="owl-carousel featured-venues-slider owl-theme">
                <!-- Blog -->
                <Carousel
                    :breakpoints="breakpoints"
                    :settings="settings"
                    :wrap-around="true"
                >
                  <Slide v-for="item in data" :key="item.id">
                    <div class="featured-venues-item text-start">
                      <div class="listing-item mb-0">
                        <div class="listing-img">
                          <router-link
                              :to="`/tin-tuc/${encodeURIComponent(item?.slug)}`"
                          >
                            <img
                                :alt="item?.media?.documentId"
                                :src="
                                  item?.media?.url
                                    ? `${url + item.media.url}`
                                    : require('@/assets/img/bg/login_bg.jpg')
                                "
                            />
                          </router-link>
                          <div class="fav-item-venues news-sports">
                            <span class="tag tag-blue">{{
                                item?.news_category?.name
                              }}</span>
                          </div>
                        </div>
                        <div class="listing-content news-content">
                          <h3 class="listing-title blog-title">
                            <router-link
                                :to="`/tin-tuc/${encodeURIComponent(item?.slug)}`"
                            >{{ item?.title }}
                            </router-link
                            >
                          </h3>
                          <div class="short-description">
                            {{ item?.short_description }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Slide>
                  <template #addons>
                    <Navigation/>
                  </template>
                </Carousel>
                <!-- /Blog -->
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
  <layout-footer></layout-footer>
</template>
<script>
import {Carousel, Navigation, Slide} from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import Blog_Details from "@/assets/json/blog-details.json";
import Blog_Details_Comment from "@/assets/json/blog-details-comment.json";
import {useRoute} from "vue-router";
import {GET_NEWS, GET_NEWS_BY_SLUG} from "@/graphql/operations/news.ts";
import {useQuery} from "@vue/apollo-composable";
import {ref, watch} from "vue";
import { useAuthStore } from "@/stores/auth";

export default {
  data() {
    const route = useRoute();
    const url = process.env.VUE_APP_SERVER_URL;
    const params = route.params.title;
    const detail = ref([]);
    const data = ref([]);
    const title = ref();
    const authStore = useAuthStore();

    const {result: news} = useQuery(GET_NEWS_BY_SLUG, () => ({
      slug: params[1],
    }));

    const {result: newsList} = useQuery(GET_NEWS, () => ({
      slug: params[1],
    }));

    watch(
        newsList,
        () => {
          data.value = newsList.value.news;
        },
        {deep: true}
    );

    watch(
        news,
        () => {
          detail.value = news.value.news[0]?.data;
          title.value = news.value.news[0]?.data?.title;
        },
        {deep: true}
    );

    return {
      authStore,
      detail,
      data,
      url,
      Blog_Details_Comment: Blog_Details_Comment,
      Blog_Details: Blog_Details,
      title,
      text: "Trang chủ",
      text1: "Tin tức",
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        767: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        991: {
          itemsToShow: 2,
          snapAlign: "start",
        },
        1024: {
          itemsToShow: 3,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Navigation,
  },
  methods: {
    toggleSelected(item) {
      item.isSelected = !item.isSelected;
    },
  },
};
</script>


